import React, { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import "aos/dist/aos.css";
import "./ServiceCards.css";

function ServiceCard() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true, offset: 100, easing: "ease-in-out" });
    AOS.refresh();
  }, []);

  // Trasforma il testo in array di paragrafi
  const getTextParagraphs = (key, fallback) => {
    let val = t(key, { defaultValue: fallback });
    if (typeof val === "string") {
      val = val.replace(/\\n/g, "\n");
      return val.split("\n\n");
    }
    if (Array.isArray(val)) return val;
    if (val && typeof val === "object" && "text" in val && typeof val.text === "string") {
      return val.text.replace(/\\n/g, "\n").split("\n\n");
    }
    return [String(val)];
  };

  const services = [
    {
      key: "sitiWeb",
      title: t("serviziPage.sitiWebTitolo", "Siti Web Vetrina"),
      desc: getTextParagraphs(
        "serviziPage.sitiWebDesc",
        `Realizzo siti web vetrina moderni, veloci e completamente responsive, ideali per valorizzare la tua attività online.

Ogni progetto è curato con un design elegante e una struttura intuitiva, pensata per offrire un'esperienza di navigazione fluida su qualsiasi dispositivo.

Grazie a tecniche avanzate di ottimizzazione SEO, il tuo sito verrà indicizzato correttamente su Google e potrà raggiungere nuovi clienti in modo naturale.

Un sito vetrina firmato Andromeda Programmazione è uno strumento professionale pensato per rafforzare la tua identità digitale e migliorare la presenza online della tua azienda.`
      ),
       /* eslint-disable no-undef */
      image: `${process.env.PUBLIC_URL}/images/siti.png`,
    },
    {
      key: "ecommerce",
      title: t("serviziPage.ecommerceTitolo", "E-commerce"),
      desc: getTextParagraphs(
        "serviziPage.ecommerceDesc",
        `Realizziamo piattaforme di vendita online complete, moderne e performanti, progettate per far crescere il tuo business in modo rapido e sicuro.

Ogni negozio digitale è costruito per gestire ordini, carrelli, pagamenti e report con semplicità, grazie a dashboard intuitive e personalizzabili.

Il tuo e-commerce offrirà ai clienti un'esperienza d'acquisto fluida e coinvolgente, accessibile da qualsiasi dispositivo, aumentando le vendite e la fidelizzazione.

Integrando tecniche SEO avanzate e strumenti di marketing digitale, il tuo store sarà visibile ai clienti giusti al momento giusto.

Investire in un e-commerce oggi significa espandere la tua attività, conquistare nuovi mercati e trasformare il tuo brand in una presenza digitale competitiva e redditizia.`
      ),
      image: `${process.env.PUBLIC_URL}/images/vendita.png`,
    },
    {
      key: "webApp",
      title: t("serviziPage.webAppTitolo", "Web App & Gestionali"),
      desc: getTextParagraphs(
        "serviziPage.webAppDesc",
        `Progettiamo soluzioni digitali su misura per la gestione completa della tua azienda.

Dall’automatizzazione dei processi alla gestione clienti, magazzino, prenotazioni e reportistica avanzata, ogni applicazione è pensata per semplificare il lavoro quotidiano e ottimizzare le risorse.

Utilizziamo tecnologie moderne e database affidabili, combinando approcci modulari e interfacce intuitive, per garantire applicazioni veloci, sicure e altamente personalizzabili.

Le nostre web app e gestionali sono responsive, facili da usare e progettate per crescere con la tua azienda, offrendo strumenti pratici per migliorare efficienza e produttività.`
      ),
       /* eslint-disable no-undef */
      image: `${process.env.PUBLIC_URL}/images/gestionali.png`,
    },
    {
      key: "microservizi",
      title: t("serviziPage.microserviziTitolo", "Sistemi a Microservizi"),
      desc: getTextParagraphs(
        "serviziPage.microserviziDesc",
        `Sviluppiamo architetture distribuite moderne basate su microservizi, per creare sistemi digitali flessibili, scalabili e altamente performanti.

Ogni componente è studiato per garantire velocità, affidabilità e continuità operativa, ottimizzando tempi di risposta e gestione dei carichi di lavoro.

Utilizziamo linguaggi e database moderni, approcci modulari e tecnologie innovative, per assicurare sicurezza dei dati e facilità di manutenzione.

Con i nostri sistemi, le aziende possono crescere rapidamente, integrare nuove funzionalità senza interruzioni e offrire un’esperienza utente fluida e costante.

Il risultato è una piattaforma potente, veloce e pronta a sostenere le sfide del business digitale moderno.`
      ),
       /* eslint-disable no-undef */
      image: `${process.env.PUBLIC_URL}/images/microservizi.png`,
    },
    {
      key: "reti",
      title: t("serviziPage.retiTitolo", "Sistemi di Reti e Virtualizzazione"),
      desc: getTextParagraphs(
        "serviziPage.retiDesc",
        `Configuriamo reti aziendali robuste, server sicuri e macchine virtuali performanti, garantendo una gestione efficiente di tutte le risorse IT.

Analizziamo le performance di rete, interveniamo sulla sicurezza e curiamo la manutenzione infrastrutturale per prevenire problemi e ottimizzare i processi.

Offriamo supporto completo per ambienti Linux e Windows Server, con soluzioni scalabili che crescono insieme alla tua attività.

Un’infrastruttura ben progettata riduce i tempi di inattività, aumenta l’affidabilità dei servizi e permette di lavorare in sicurezza e senza interruzioni.

Grazie a tecnologie moderne e approcci innovativi, ogni sistema è pensato per massimizzare velocità, efficienza e controllo, semplificando la gestione IT e garantendo risultati duraturi.`
      ),
       /* eslint-disable no-undef */
      image: `${process.env.PUBLIC_URL}/images/reti.png`,
    },
  ];

  return (
    <>
      <Helmet>
        <title>{t("serviziPage.metaTitolo", "Servizi | Andromeda Programmazione")}</title>
        <meta
          name="description"
          content={t(
            "serviziPage.metaDescrizione",
            "Scopri i servizi offerti da Andromeda Programmazione: siti web, e-commerce, gestionali, microservizi e soluzioni IT personalizzate per aziende e professionisti."
          )}
        />
      </Helmet>

      <section id="servizi" className="py-5">
        <div className="container">
          <h2 className="fw-bold mb-5 glow-text text-center" data-aos="fade-up">
            {t("serviziPage.titoloSezione", "I Nostri Servizi")}
          </h2>

          {services.map((s, index) => (
            <div
              key={index}
              className="row align-items-center mb-5 service-card"
              data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
            >
              <div className={`col-md-6 ${index % 2 === 0 ? "" : "order-md-2"}`}>
                <img
                  src={s.image}
                  alt={s.title}
                  className="img-fluid rounded shadow-lg service-image"
                  loading="lazy"
                />
              </div>

              <div className={`col-md-6 ${index % 2 === 0 ? "" : "order-md-1"}`} data-aos="fade-up">
                <h4 className="service-title mb-4">{s.title}</h4>
                <div className="service-content">
                  {s.desc.map((p, i) => (
                    <p key={i}>{p}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default ServiceCard;
